// Home Page feature collection product Slider

$('.collection-slider ').slick({
  dots: false,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1

});
